import React, { useState } from 'react'
import { api } from '../../../infrastructure/api'
import { Guid } from '../../../infrastructure/guid'
import { Filters, Site, TruckTransportItem as TruckTransportItemModel } from '../truckModels'
import { MeanOfTransportation } from '../truckStore'

export function useTruckTransportList() {
    let [listItems, setListItems] = useState<TruckTransportItem[]>([])
    let [selectedIds, setSelectedIds] = useState<Guid[]>([])

    let constructFiltersQuery = (filters: Filters) => {
        let filterProperties = Object.keys(filters)

        let initializedFilters = filterProperties
            .filter(x => !Array.isArray(filters[x]))
            .filter(x => (filters[x] !== undefined && filters[x] !== null))
            .map(x => `${x}=${filters[x]}`)

        let collectionFilters = filterProperties
            .filter(x => Array.isArray(filters[x]))
            .filter(x => filters[x] && filters[x].length > 0)
            .flatMap(x => filters[x].map(value => `${x}=${value}`))

        return initializedFilters.concat(collectionFilters).join('&')
    }

    async function search(filters: Filters, mot: MeanOfTransportation) {
        filters.meanOfTransportation = mot
        let filtersQuery = constructFiltersQuery(filters)
        let route = filtersQuery ? `truck?${filtersQuery}` : 'truck'
        let searchResult = await api.get<TruckTransportItem[]>(route)
        setListItems([])
        setListItems(searchResult)
    }

    return { listItems, search, selectedIds, setSelectedIds }
}

type TruckTransportItem = TruckTransportItemModel & { destinationSites: Site[] }